import React, { useState } from 'react';
import TutorialOverlay from '../Tutorial/TutorialOverlay';
import { TT_FIELD_INTERACTIVE_STEPS, TT_ADMIN_INTERACTIVE_STEPS } from './timeTrackerInteractiveSteps';

/**
 * Spotlight walk of the live Time Tracker page (not the illustrated video tour).
 */
const TimeTrackerInteractiveTour = ({ variant = 'field', onClose }) => {
  const steps = variant === 'admin' ? TT_ADMIN_INTERACTIVE_STEPS : TT_FIELD_INTERACTIVE_STEPS;
  const [index, setIndex] = useState(0);
  const step = steps[index];
  if (!step) return null;

  return (
    <TutorialOverlay
      step={step}
      currentStepIndex={index}
      totalSteps={steps.length}
      isLastStep={index === steps.length - 1}
      onNext={() => {
        if (index >= steps.length - 1) onClose();
        else setIndex((i) => i + 1);
      }}
      onPrevious={() => setIndex((i) => Math.max(0, i - 1))}
      onClose={onClose}
      onSkip={onClose}
      onGoToStep={setIndex}
    />
  );
};

export default TimeTrackerInteractiveTour;
